import { ref } from 'vue'

const toasts = ref([])
let idCounter = 0

function removeToast(id) {
  toasts.value = toasts.value.filter(t => t.id !== id)
}

function toastIcon(type) {
  const map = { success: '✓', error: '✗', warning: '⚠', info: 'ℹ' }
  return map[type] || 'ℹ'
}

function showToast(message, type = 'info', duration = 3000) {
  const id = ++idCounter
  toasts.value.push({ id, message, type })
  if (duration > 0) {
    setTimeout(() => removeToast(id), duration)
  }
}

export { showToast }

export function useToast() {
  return { toasts, toastIcon, removeToast }
}
